
export const palette = {
	primaryDarkBlue          : "#126bd5",
	secondaryLightGrey       : "#e7e7e7",
	secondaryWhite           : "#ffffff",
	secondaryDarkGrey        : "#757575",
	secondaryDarkGrey50      : "rgba(117, 117, 117, 0.5)",
	secondaryBlack25         : "00000040",
	secondaryBackgroundGrey  : "#f5f5f5",
	primaryRareBlue          : "#eef8ff",
	primaryDarkBlue10        : "rgba(18, 107, 213, 0.1)",
	primaryLightBlue         : "#439aff",
	secondaryBlack           : "#000000",
	secondaryBlack50         : "rgba(0, 0, 0, 0.5)",
	secondaryLighterDarkGrey : "#858585",
	tertiaryErrorRed         : "#e02020",
	tertiarySuccessGreen     : "#56a700",
	tertiaryYellow           : "#f9a74e",
	tertiaryPink             : "#ff177e",
	darkModeWhite20          : "rgba(255, 255, 255, 0.2)",
	darkModeDarkBlue50       : "rgba(18, 107, 213, 0.5)",
	darkModeWhite80          : "rgba(255, 255, 255, 0.8)", // #ffffffcc
	darkModeDarkGrey20       : "rgba(117, 117, 117, 0.2)",
	darkModeDarkGrey         : "rgb(26, 26, 26)",
	darkModeInclinedBlack1   : "#272727",
	darkModeInclinedBlack2   : "#1a1a1a",
	lightModeGreyPlaceholder : "rgba( 75, 75, 75, 0.5)"
};

export const buttonsColorLight = {
	primaryBtn: {
		default: {
			text       : palette.secondaryWhite,
			background : `linear-gradient(to bottom, ${ palette.primaryDarkBlue } 0%, #439aff 100%)`
		},
		clicked: {
			text       : palette.secondaryWhite,
			background : palette.secondaryDarkGrey50
		},
		hover: {
			text       : palette.secondaryWhite,
			background : `linear-gradient(to bottom, ${ palette.primaryDarkBlue } 0%, ${ palette.primaryDarkBlue } 100%)`
		},
		disabled: {
			text       : palette.secondaryWhite,
			background : "linear-gradient(1deg, #00000073, #0000009c)"
		}
	},
	secondaryBtn: {
		default: {
			text       : palette.secondaryDarkGrey,
			background : palette.secondaryWhite,
			border     : palette.secondaryLightGrey
		},
		// same as default
		hover: {
			text       : palette.secondaryDarkGrey,
			background : palette.secondaryBackgroundGrey,
			border     : palette.secondaryLightGrey
		},
		clicked: {
			text       : palette.primaryDarkBlue,
			background : palette.primaryRareBlue,
			border     : palette.primaryDarkBlue
		}
	},
	tertiaryBtn: {
		default: {
			text       : palette.primaryDarkBlue,
			background : "transparent",
			border     : palette.primaryDarkBlue
		},
		hover: {
			text       : palette.primaryDarkBlue,
			background : palette.primaryRareBlue,
			border     : palette.primaryDarkBlue
		},
		clicked: {
			text       : palette.primaryDarkBlue,
			background : palette.primaryRareBlue,
			border     : palette.primaryDarkBlue
		}
	},
	textBtn: {
		default: {
			text       : palette.secondaryBlack,
			background : "inherit"
		}
	}
};

export const buttonsColorDark = {
	primaryBtn: {
		default: {
			text       : palette.secondaryWhite,
			background : `linear-gradient(to bottom, ${ palette.primaryDarkBlue } 0%, #439aff 100%)`
		},
		clicked: {
			text       : palette.secondaryWhite,
			background : palette.secondaryDarkGrey50
		},
		hover: {
			text       : palette.secondaryWhite,
			background : `linear-gradient(to bottom, ${ palette.primaryDarkBlue } 0%, ${ palette.primaryDarkBlue } 100%)`
		},
		disabled: {
			text       : palette.primaryDarkBlue,
			background : "linear-gradient(1deg, rgb(255 246 246 / 61%), rgb(255 255 255 / 61%))"
		}
	},
	secondaryBtn: {
		default: {
			text       : palette.secondaryWhite,
			background : palette.darkModeDarkGrey20,
			border     : palette.darkModeWhite20
		},
		// same as default
		hover: {
			text       : palette.secondaryWhite,
			background : palette.darkModeDarkGrey20,
			border     : palette.darkModeWhite20
		},
		clicked: {
			text       : palette.secondaryWhite,
			background : palette.darkModeWhite20,
			border     : palette.primaryDarkBlue
		}
	},
	tertiaryBtn: {
		default: {
			text       : palette.primaryDarkBlue,
			background : "transparent",
			border     : palette.primaryDarkBlue
		},
		hover: {
			text       : palette.primaryDarkBlue,
			background : palette.darkModeDarkBlue50,
			border     : palette.primaryDarkBlue
		},
		clicked: {
			text       : palette.primaryDarkBlue,
			background : palette.darkModeDarkBlue50,
			border     : palette.primaryDarkBlue
		}
	},
	textBtn: {
		default: {
			text       : palette.primaryDarkBlue,
			background : "inherit"
		}
	}
};

export const light = {
	body: {
		primary: palette.secondaryWhite
	},
	text: {
		primary   : palette.secondaryBlack,
		secondary : palette.secondaryDarkGrey,
		tertiary  : palette.secondaryBlack
	},
	background: {
		primary   : palette.secondaryWhite,
		secondary : palette.secondaryWhite,
		tertiary  : palette.secondaryWhite
	},
	background2: {
		primary: palette.secondaryBackgroundGrey
	},
	boxShadow: {
		primary: "rgb(0 0 0 / 12%) 4px 4px 8px 0px"
	},
	border: {
		primary: palette.secondaryLightGrey
	},
	selectedState: {
		primary: palette.primaryDarkBlue10
	},
	input: {
		primary: palette.secondaryLightGrey
	},
	inputPlaceHolder: {
		primary: palette.lightModeGreyPlaceholder
	},
	dialog: { primary: palette.secondaryWhite, secondary: palette.secondaryWhite },
	...buttonsColorLight
};

export const dark = {
	body: {
		primary: palette.secondaryBlack
	},
	text: {
		primary   : palette.darkModeWhite80,
		secondary : palette.secondaryDarkGrey,
		tertiary  : palette.darkModeWhite80
	},
	background: {
		primary   : palette.darkModeDarkGrey20,
		secondary : palette.secondaryBlack,
		tertiary  : palette.darkModeInclinedBlack1
	},
	// for hover state
	background2: {
		primary: palette.darkModeDarkGrey20
	},
	boxShadow: {
		primary: "0 0 8px 2px rgba(255, 255, 255, 0.14)"
	},
	border: {
		primary   : palette.darkModeWhite20,
		secondary : palette.secondaryDarkGrey50
	},
	selectedState: {
		primary: palette.darkModeDarkBlue50
	},
	input: {
		primary: palette.darkModeDarkGrey20
	},
	inputPlaceHolder: {
		primary: palette.darkModeWhite20
	},
	dialog: { primary: palette.darkModeInclinedBlack1, secondary: palette.darkModeInclinedBlack2 },
	...buttonsColorDark

};
